import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c946dde6&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c946dde6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c946dde6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c946dde6')) {
      api.createRecord('c946dde6', component.options)
    } else {
      api.reload('c946dde6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c946dde6&scoped=true&lang=pug", function () {
      api.rerender('c946dde6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/account/profile/skeleton/index.vue"
export default component.exports